import React from "react";
import classes from "./MemberDetails.module.css";
import constants from "../../../../globalization";
import PopupHeader from "../PopupHeader";
import FireboardUtils from "../../../../util/fireboard-util";

const MemberDetails = (props) => {
  const {
    activeItem: {
      firstName = "",
      lastName = "",
      phoneNumber = "",
      emailAddress = "",
    },
    onClose,
    iso2,
  } = props || {};

  return (
    <div className={classes.container}>
      <PopupHeader title={constants.memberDetails} onClose={onClose} />
      <div className={classes.itemsContainer}>
        <div className={classes.item}>
          <span className={classes.labelTextStyle}>{constants.firstName}</span>
          <span className={classes.valueTextStyle}>{firstName}</span>
        </div>
        <div className={classes.item}>
          <span className={classes.labelTextStyle}>{constants.lastName}</span>
          <span className={classes.valueTextStyle}>{lastName}</span>
        </div>
        <div className={classes.item}>
          <span className={classes.labelTextStyle}>
            {constants.phoneNumber}
          </span>
          <span className={classes.valueTextStyle}>{FireboardUtils.formattedPhoneNumber(phoneNumber, iso2)}</span>
        </div>
        <div className={classes.item}>
          <span className={classes.labelTextStyle}>
            {constants.emailAddress}
          </span>
          <span className={classes.valueTextStyle}>{emailAddress}</span>
        </div>
      </div>
    </div>
  );
};

export default MemberDetails;
